<template>
  <div class="Form__group" :class="{ 'is--error' : error }">
    <label v-show="label" :for="id">{{ label }} <abbr v-show="required" title="Requis">*</abbr></label>
    <input class="Form__control"
     :id="id"
     :max="max ?? (type !== 'number' ? 191 : undefined)"
     :min="min"
     :type="type"
     :name="name"
     :placeholder="placeholder"
     :required="!!required"
     :aria-required="!!required"
     :disabled="!!disabled"
     :readonly="!!readonly"
     :value="modelValue"
     @input="$emit('update:modelValue', $event.target.value)"
     :autocomplete="autocomplete"

    >
    <div class="errors__container" v-if="error && (typeof error !== 'boolean')">
      <span v-if="error" class="error">{{ error }}</span>
      <template v-else-if="errors">
        <span v-for="error in errors" class="error">{{ error }}</span>
      </template>
    </div>

  </div>
</template>

<script>
  export default {
    props : [ 'name', 'label', 'id', 'type', 'placeholder', 'required', 'error', 'errors', 'modelValue', 'max', 'min', 'disabled', 'readonly', 'autocomplete'],
  }
</script>
